import Fieldset from './Fieldset';
import FieldsetAvatar from './FieldsetAvatar';
import FieldsetCheckbox from './FieldsetCheckbox';
import FieldsetFooter from './FieldsetFooter';
import FieldsetFooterAction from './FieldsetFooterAction';
import FieldsetFooterStatus from './FieldsetFooterStatus';
import FieldsetTitle from './FieldsetTitle';

export default {
  Fieldset,
  Footer: FieldsetFooter,
  FooterStatus: FieldsetFooterStatus,
  FooterAction: FieldsetFooterAction,
  Avatar: FieldsetAvatar,
  Checkbox: FieldsetCheckbox,
  Title: FieldsetTitle,
};
